/**
 * Analyser tab options showing status...
 */
export enum OptionsTabShowingStatus {
    None,
    Select,
    Chosen
}